import { useCallback, useEffect } from "react"
import { useToasts } from "./useToast"

export function useHideToast(info: {
  id: string
  keepOpen?: boolean
  onClose?: () => void
}) {
  const [_, setToasts] = useToasts()
  const id = info.id
  const onClose = info.onClose
  const hideToast = useCallback(() => {
    setToasts((toasts) => toasts.filter((t) => t.id !== id))
    onClose?.()
  }, [id, setToasts, onClose])

  useEffect(() => {
    if (info.keepOpen) return
    const timeout = setTimeout(() => {
      hideToast()
    }, 5000)
    return () => clearTimeout(timeout)
  }, [info.keepOpen, hideToast])

  return hideToast
}
